import React, { useState }  from 'react';
import { Device } from "../../interfaces/Device";
import { VICU } from "../../interfaces/VICU";
import { useTranslation } from "react-i18next";
import CustomTabs from "../tabs/CustomTabs";
import { CCMCentral } from "../../pages/CCM/CCMCentral";
import { CCMPatient } from "../../interfaces/CCMPatient";

interface RPMDashboardTabsProps {
  visibleDevices: Device[];
  visiblePatients: CCMPatient[];
  monitorGroupList: VICU[];
  setSelectedVICU: (vicu: VICU | null) => void;
  selectedVICU: VICU | null;
  updateDeviceList: () => void;
  setDevices: (devices: Device[]) => void;
  useSyspool: boolean;
  organization_id: string;
  refreshPatients?: () => void; // Add refresh function prop

  clinicOptions: { value: string; label: string }[]; // Add the dropdownOptions prop
  clinicDropdownTitle: string;
  selectedClinicItem: string | undefined;
  onClinicChange: (value: string) => void; // Add this prop

  filterOptions: { value: number; label: string }[]; // Add the dropdownOptions prop
  filterDropdownTitle: string;
  selectedFilterItem: number | undefined;
  onFilterChange: (value: number) => void; // Add this prop

  cohortList?: any[]; // Add cohort list prop
  selectedCohort?: any; // Add selected cohort prop  
  onCohortChange?: (cohort: any) => void; // Add cohort change handler

}

const RPMDashboardTabs: React.FC<RPMDashboardTabsProps> = ({
  organization_id,
  visibleDevices, 
  visiblePatients,
  monitorGroupList, 
  setSelectedVICU, 
  selectedVICU, 
  updateDeviceList, 
  setDevices, 
  useSyspool,
  refreshPatients,
  clinicOptions,
  onClinicChange,
  clinicDropdownTitle,
  selectedClinicItem,
  filterOptions,
  onFilterChange,
  filterDropdownTitle,
  selectedFilterItem,

  cohortList,
  selectedCohort,
  onCohortChange

}) => {

    const { t } = useTranslation();
    const [currentTab, setCurrentTab] = useState<number>(0);
    const [selectedClinic, setSelectedClinic] = useState<string>(
        selectedClinicItem || (clinicOptions?.length > 0 ? clinicOptions[0].value : '')
    );
    const [selectedFilter, setSelectedFilter] = useState<number>(selectedFilterItem || 0);

    // Create the base arrays - removed NEWS PRIORITY tab
    const tabNames = [
		t("CCM Central"),
    ];

    const tabComponents = [
		<CCMCentral organization_id={organization_id} patientlist={visiblePatients} devicelist={visibleDevices} filterValue={selectedFilter} refreshPatients={refreshPatients}>
		{/* Cohort selection moved to top navigation, no longer needed here */}
	</CCMCentral>
    ];

    const handleClinicChange = (value: string) => {
        setSelectedClinic(value);
        onClinicChange(value);
    };
    const handleFilterChange = (value: string) => {
        setSelectedFilter(Number (value));
        onFilterChange(Number (value));
    };


    return (
		<div>
			<CustomTabs 
				tabNames={tabNames} 
				tabComponents={tabComponents} value={currentTab}
                onTabChange={setCurrentTab}

				clinicOptions={clinicOptions} // Pass dropdownOptions to CustomTabs
                selectedClinic={selectedClinic}
                onClinicChange={handleClinicChange}
                clinicDropdownTitle={clinicDropdownTitle}
	
				filterOptions={filterOptions} // Pass dropdownOptions to CustomTabs
                selectedFilter={'' + selectedFilter}
                onFilterChange={handleFilterChange}
                filterDropdownTitle={filterDropdownTitle}

				// Add cohort props for top navigation
				cohortList={cohortList}
				selectedCohort={selectedCohort}
				onCohortChange={onCohortChange}

			/>
		</div>
	);

};

export default RPMDashboardTabs;